import { Logger } from "./logger";
Logger.init();

import { createApp } from "vue";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import {
  VueQueryPlugin,
  type VueQueryPluginOptions,
} from "@tanstack/vue-query";

import { Syncer } from "./repositories/Syncer";
import App from "./App.vue";
import router from "./router";
import { pinia } from "@/stores/pinia";

import "./style/app.scss";
import { queryClient } from "./stores/queries/query-client";
import VueDndKitPlugin from "@vue-dnd-kit/core";
import { setupI18n } from "./lang/i18n";
import preloadAssets from "./utils/preloadAssets";
import { setupInstallPrompt } from "./composable/useInstallPrompt";
import { prepareHandwritingAtBoot } from "./stores/HandwritingFeatureState";
import { openDatabase } from "./repositories/database";

// Capture `beforeinstallprompt` dès le démarrage (l'événement peut arriver
// avant le montage du premier composant).
setupInstallPrompt();

// Précharge la reconnaissance d'écriture (utilisateurs de l'outil seulement)
// avant qu'un plan — et le tas mémoire de DrawingWeb — ne soit chargé.
prepareHandwritingAtBoot();

const app = createApp(App);

const syncer = new Syncer();
app.provide("syncer", syncer);

// use to preload and cache static files
app.use(preloadAssets);

const vueQueryPluginOptions: VueQueryPluginOptions = {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 5,
      },
    },
  },
  queryClient,
};

app.use(VueQueryPlugin, vueQueryPluginOptions);

app.use(pinia);

app.use(router);

app.use(ElementPlus);

app.use(VueDndKitPlugin, {
  defaultOverlay: {
    styles: {
      transition: "none",
    },
  },
});

setupI18n(app);

// Après l'i18n (le message d'erreur est traduit), avant le montage : une base
// qui ne s'ouvre pas doit se voir au premier écran, pas au premier plan ouvert.
void openDatabase();

app.mount("#app");
